import { TUserWithConnect } from '@cloud-wave/neon-common-lib';

import CONTACT_STATES from 'lib/common/constants/contactStates';

import { TConfig } from 'lib/common/types/Config';
import TFetch from 'lib/common/types/Fetch';

import THandleContactChange from '../types/HandleContactChange';
import addInteractionHistoryItem from '../utils/addInteractionHistoryItem';

interface IHandleConnectedContact {
  contact: connect.Contact;
  handleContactChange: THandleContactChange;
  fetch_: TFetch;
  config: TConfig;
  tokens?: any;
  getUser: () => TUserWithConnect | null;
}

export default async function handleConnectedContact({
  contact,
  handleContactChange,
  fetch_,
  config,
  tokens,
  getUser,
}: IHandleConnectedContact) {
  handleContactChange({ contact, status: CONTACT_STATES.CONNECTED, eventTimestamp: Date.now() });

  const user = getUser();

  if (!user) {
    return;
  }

  addInteractionHistoryItem({ contact: contact, fetch_, config, tokens, user });
}
